import React from "react";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import "./styles.css";
import PageShell from "../UI/PageShell";

const SiteSettings = ({ history, client, sites }) => {
  const default_site_id = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;

  const [settingActiveSite, setSettingActiveSite] =
    React.useState(default_site_id);

  const changeActiveSiteHandler = (site_id) => {
    setSettingActiveSite(site_id);
  };

  const saveActiveSiteHandler = async () => {
    if (
      await AlertService.confirm("", `Are you sure you want to change site?`)
    ) {
      settingActiveSite &&
        localStorage.setItem("default_site_id", `${settingActiveSite}`);

      ToastUtil.success("Save site settings successfully!");
    }
  };

  return (
    <PageShell title="Site settings" eyebrow="Work location" description="Choose the site used for schedules, attendance, leave, and claims." backTo="/">
      <div className="portal-form-card">
        <div className="portal-form-section-title">
          <h2>Active workplace</h2>
          <p>Your selected site controls the information shown throughout the portal.</p>
        </div>
        <div className="form-group">
          <label htmlFor="siteSelect" className="font-weight-bold text-muted">
            Client
          </label>
          <p className="text-muted">{client && client.name}</p>
          <label htmlFor="siteSelect" className="font-weight-bold text-muted">
            Site
          </label>
          <select
            className="form-select dropdown"
            id="siteSelect"
            value={settingActiveSite ? settingActiveSite : 0}
            onChange={(e) => changeActiveSiteHandler(e.target.value)}
          >
            {sites &&
              sites.map((site) => (
                <option key={site.id} value={site.id}>
                  {site.name}
                </option>
              ))}
          </select>
        </div>
        <button
          type="button"
          className="btn btn-design btn-brand btn-block mt-4"
          onClick={() => {
            saveActiveSiteHandler();
          }}
        >
          Save
        </button>
      </div>
    </PageShell>
  );
};

export default SiteSettings;
